import React, { useState, useEffect, useCallback } from 'react';
import EditStaff from '../../AddsEdits/Adult/EditStaff.js';
import AddStaff from '../../AddsEdits/Adult/AddStaff.js';
import { SERVER_URL } from '../../../constants.js'
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


function Staff(props) {
  const { selectedPerson } = props;
  const [adult, setAdult] = useState(null);
  const [staff, setStaff] = useState(null);
  const [allRoles, setAllRoles] = useState([]);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

  let imgPath= process.env.PUBLIC_URL || '/assets/img/staff.png';
  
  const {
    id: AdultId, 
    dateAdded, 
    adultName, 
    adultSurname, 
    adultEmail, 
    adultPhone, 
    adultNationality, 
  } = adult || {};

  const {
    staffid: StaffId, 
    notes: StaffNotes,
    roles = [],
    username,
    policecheck,
    dsl,
    firstaid
  } = staff || {};

  const showToast = (message, severity = 'success') => {
    setToast({ open: true, message, severity });
  };
  const handleCloseToast = () => {
    setToast({ ...toast, open: false });
  };
  
  const fetchAdult = useCallback(() => {
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/adult/${selectedPerson.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return null;
        } else if (response.ok) {
          return response.json();
        } else {
          showToast('failed to fetch adult record', 'error')
        }
      })
      .then((data) => {
        setAdult(data);
      })
      .catch((err) => console.error(err));
  }, [selectedPerson.id]);

  const fetchStaff = useCallback(() => {
    console.log('fetchStaff'); // ✅ debugging
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/staffroles/${selectedPerson.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return null;
        } else if (response.ok) {
          return response.json();
        } else {
          showToast('failed to fetch staff record', 'error')
        }
      })
      .then((data) => {
          setStaff(data && data.length ? data[0] : null);
      })
      .catch((err) => console.error(err));
  }, [selectedPerson.id]);

  const fetchAllRoles = useCallback(() => {
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/roles`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) showToast('failed to fetch roles', 'error')
        return res.json();
      })
      .then(data => setAllRoles(data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetchAdult();
    fetchStaff();
    fetchAllRoles();
  }, [fetchAdult, fetchStaff, fetchAllRoles]);

  const addStaff = (newStaff) => {
      const token = sessionStorage.getItem("bearer"); 
      fetch(`${SERVER_URL}api/staff/${AdultId}`, {
        method: 'POST', 
        headers: {
          'Content-Type':'application/json',
          'Authorization' : `Bearer ${token}`
        },
        body: JSON.stringify(newStaff)
      })
      .then(response => {
        if (response.ok) {
          showToast('Staff record Aded');
          fetchStaff();
        }
        else {
          showToast('failed to add staff record', 'error');
        }
      })
      .catch(err => console.error(err))
    }
    
    const editStaff = (staff, id) => {
    const token = sessionStorage.getItem("bearer"); 
    fetch(`${SERVER_URL}api/staff/${id}`, {
      method: 'PUT', 
      headers: {
        'Content-Type':'application/json',
        'Authorization' : `Bearer ${token}`
      },
      body: JSON.stringify(staff)
    })
    .then(response => {
      if (response.ok) {
        showToast('Staff record Edited');
        fetchAdult();
        fetchStaff();
      }
      else {
        showToast('failed to edit staff record', 'error');
      }
    })
    .catch(err => console.error(err))
  }

  const updateRoles = (newRoles, StaffId) => {
    const token = sessionStorage.getItem("bearer"); 
    fetch(`${SERVER_URL}api/staff/${StaffId}/roles`, {
      method: 'PUT', 
      headers: {
        'Content-Type':'application/json',
        'Authorization' : `Bearer ${token}`
      },
      body: JSON.stringify({roles: newRoles})
    })
    .then(response => {
      if (response.ok) {
        showToast('Staff roles updated');
        fetchStaff();
      }
      else {
        showToast('failed to edit staff roles', 'error');
      }
    })
    .catch(err => console.error(err))
  }

  return (
    <React.Fragment>
      <div className="detail-card" style={{ padding: '20px 0' }}>
        <table style={{ width: '80%', textAlign: 'left', margin: 'auto', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td rowSpan="2" style={{ textAlign: 'center' }}><img className="br-0 h3 w3 dib" alt={selectedPerson.id} src={imgPath} /></td>
              <td>DB ref: {AdultId}</td>
              <td>Added: {dateAdded}</td>
            </tr>
            <tr>
            <td style={{ textAlign: 'left' }}>{adultName} {adultSurname}</td>
            <td>Nationality: {adultNationality}</td>
            </tr>
            <tr>
            
              
              <td colSpan="1"></td>
              <td>Email: {adultEmail}</td>
            <td>Phone: {adultPhone}</td>
            </tr>
            <tr style={{ height: '50px' }}><td colSpan="4" > </td></tr>
            <tr><td>Staff Id: </td><td colSpan="3">{StaffId}</td></tr>
            <tr><td>Notes:</td><td colSpan="3">{StaffNotes}</td></tr>
            <tr><td>Roles:</td>
              <td colSpan="3">
                {roles.map((r, i) => (
                  <React.Fragment key={r}>
                    <span className="badge">{r}</span>
                   {i < roles.length - 1 && ', '}
                 </React.Fragment>
                ))}
              </td>
            </tr>
            <tr><td>username:</td><td colSpan="3">{username}</td></tr>
            <tr>
              <td>Police Check:</td>
              <td colSpan="3">{policecheck ? 'Yes' : 'No'}</td>
            </tr>
            <tr>
              <td>DSL Trained:</td>
                <td colSpan="3">{dsl ? 'Yes' : 'No'}</td>
            </tr>
            <tr>
              <td>First Aid:</td>
              <td colSpan="3">{firstaid ? 'Yes' : 'No'}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <div style={{ color: '#999999', fontSize: '10px' }}>Adult: {selectedPerson.id}
          {staff ? (
            <EditStaff passedStaff={staff} allRoles={allRoles} editStaff={editStaff} updateRoles={updateRoles}/>
          ) : (
            <AddStaff addStaff={addStaff} allRoles={allRoles}/>
          )}
        </div>
        <div style={{ color: '#999999', fontSize: '10px' }}>Is authenticated: {sessionStorage.getItem('isAuthenticated') ? 'Yes' : 'No'}</div>
      </div>
        <Snackbar open={toast.open} autoHideDuration={3000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <MuiAlert onClose={handleCloseToast} severity={toast.severity} variant="filled" elevation={6}>
            {toast.message}
          </MuiAlert>
        </Snackbar>
      </React.Fragment>
  );
}

export default Staff;
